import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { CreateProdutoServicoRequest, CreateProdutoServicoResponse } from "../daos/create/create_produto_servico";
import { IComprasService } from "./compras_service";
import { CreateFornecedorSimplificadoRequest, CreateFornecedorSimplificadoResponse } from "../daos/create/create_fornecedor_simplificado";
import { GetAllFornecedorRequest, GetAllFornecedorResponse } from "../daos/read/get_all_fornecedor";
import { GetAllFuncionariosAprovadoresRequest, GetAllFuncionariosAprovadoresResponse } from "../daos/read/get_all_funcionarios_aprovadores";
import { DeleteFornecedorRequest, DeleteFornecedorResponse } from "../daos/delete/delete_fornecedor";
import { GetFornecedoresAtividadesDropDownRequest, GetFornecedoresAtividadesDropDownResponse } from "../daos/read/get_fornecedores_atividades_drop_down";
import { GetFornecedoresFamiliasDropDownRequest, GetFornecedoresFamiliasDropDownResponse } from "../daos/read/get_fornecedores_familias_drop_down";
import { GetAllCriterioAvaliacaoFornecedorRequest, GetAllCriterioAvaliacaoFornecedorResponse } from "../daos/read/get_all_criterio_avaliacao_fornecedor";
import { CreateAvaliacaoFornecedorRequest, CreateAvaliacaoFornecedorResponse } from "../daos/create/create_avaliacao_fornecedor";
import { CreateEntradasEstoqueOrdemCompraRequest, CreateEntradasEstoqueOrdemCompraResponse } from "../daos/create/create_entradas_estoque_ordem_compra";
import { GetFornecedorByIdRequest, GetFornecedorByIdResponse } from "../daos/read/get_fornecedor_by_id";
import { GetAvaliacoesByIdFornecedorRequest, GetAvaliacoesByIdFornecedorResponse } from "../daos/read/get_avaliacoes_by_id_fornecedor";
import { GetBancosByIdFornecedorRequest, GetBancosByIdFornecedorResponse } from "../daos/read/get_bancos_by_id_fornecedor";
import { GetDocumentosByIdFornecedorRequest, GetDocumentosByIdFornecedorResponse } from "../daos/read/get_documentos_by_id_fornecedor";
import { GetFornecedorDocumentoFileContentRequest } from "../daos/read/get_fornecedor_documento_file_content";
import { ToggleFornecedorDesqualificadoRequest, ToggleFornecedorDesqualificadoResponse } from "../daos/update/toggle_fornecedor_desqualificado";
import { GetAllFornecedorQualificacaoRequest, GetAllFornecedorQualificacaoResponse } from "../daos/read/get_all_fornecedor_qualificacao";
import { GetFornecedorAvaliacaoItensByIdRequest, GetFornecedorAvaliacaoItensByIdResponse } from "../daos/read/get_forneceder_avaliacao_itens_by_id";
import { DeleteFornecedorAvaliacaoRequest, DeleteFornecedorAvaliacaoResponse } from "../daos/delete/delete_fornecedor_avaliacao";
import { DeleteFornecedorBancoRequest, DeleteFornecedorBancoResponse } from "../daos/delete/delete_fornecedor_banco";
import { DeleteFornecedorDocumentoRequest, DeleteFornecedorDocumentoResponse } from "../daos/delete/delete_fornecedor_documento";
import { CreateFornecedorBancoRequest, CreateFornecedorBancoResponse } from "../daos/create/create_fornecedor_banco";
import { UpdateFornecedorBancoRequest, UpdateFornecedorBancoResponse } from "../daos/update/update_fornecedor_banco";
import { UpdateFornecedorAvaliacaoRequest, UpdateFornecedorAvaliacaoResponse } from "../daos/update/update_fornecedor_avaliacao";
import { CreateFornecedorDocumentoRequest, CreateFornecedorDocumentoResponse } from "../daos/create/create_fornecedor_documento";
import { UpdateFornecedorDocumentoRequest, UpdateFornecedorDocumentoResponse } from "../daos/update/update_fornecedor_documento";
import { CreateFornecedorRequest, CreateFornecedorResponse } from "../daos/create/create_fornecedor";
import { UpdateFornecedorRequest, UpdateFornecedorResponse } from "../daos/update/update_fornecedor";
import { GetAllServicoProdutoRequest, GetAllServicoProdutoResponse } from "../daos/read/get_all_servico_produto";
import { CreateServicoProdutoRequest, CreateServicoProdutoResponse } from "../daos/create/create_servico_produto";
import { UpdateServicoProdutoRequest, UpdateServicoProdutoResponse } from "../daos/update/update_servico_produto";
import { DeleteServicoProdutoRequest, DeleteServicoProdutoResponse } from "../daos/delete/delete_servico_produto";
import { InativarServicoProdutoLoteServicoProdutoRequest, InativarServicoProdutoLoteServicoProdutoResponse } from "../daos/update/inativar_servico_produto_lote_servico_produto";
import { GetAllRequisicaoCompraRequest, GetAllRequisicaoCompraResponse } from "../daos/read/get_all_requisicao_compra";
import { GetRequisicaoCompraByIdRequest, GetRequisicaoCompraByIdResponse } from "../daos/read/get_requisicao_compra_by_id";
import { DeleteRequisicaoCompraRequest, DeleteRequisicaoCompraResponse } from "../daos/delete/delete_requisicao_compra";
import { SendEmailRequisicaoCompraRequest, SendEmailRequisicaoCompraResponse } from "../daos/read/send_email_requisicao_compra";
import { CopyRequisicaoCompraRequest, CopyRequisicaoCompraResponse } from "../daos/create/copy_requisicao_compra";
import { FinalizarLoteRequisicaoCompraRequest, FinalizarLoteRequisicaoCompraResponse } from "../daos/update/finalizar_lote_requisicao_compra";
import { CreateRequisicaoCompraRequest, CreateRequisicaoCompraResponse } from "../daos/create/create_requisicao_compra";
import { UpdateRequisicaoCompraRequest, UpdateRequisicaoCompraResponse } from "../daos/update/update_requisicao_compra";
import { GetAllRequisicaoProdutoServicoRequest, GetAllRequisicaoProdutoServicoResponse } from "../daos/read/get_all_requisicao_compra_produto_servico";
import { GetAllAlteracaoRequisicaoCompraProdutoServicoRequest, GetAllAlteracaoRequisicaoCompraProdutoServicoResponse } from "../daos/read/get_all_alteracao_requisicao_compra_produto_servico";
import { CreateRequisicaoCompraProdutoServicoRequest, CreateRequisicaoCompraProdutoServicoResponse } from "../daos/create/create_requisicao_compra_produto_servico";
import { UpdateRequisicaoCompraProdutoServicoRequest, UpdateRequisicaoCompraProdutoServicoResponse } from "../daos/update/update_requisicao_compra_produto_servico";
import { DeleteRequisicaoCompraProdutoServicoRequest, DeleteRequisicaoCompraProdutoServicoResponse } from "../daos/delete/delete_requisicao_compra_produto_servico";
import { GetAllColetaPrecoRequest, GetAllColetaPrecoResponse } from "../daos/read/get_all_coleta_preco";
import { CopyColetaPrecoRequest, CopyColetaPrecoResponse } from "../daos/create/copy_coleta_preco";
import { DeleteColetaPrecoRequest, DeleteColetaPrecoResponse } from "../daos/delete/delete_coleta_preco";
import { FinalizarRequisicaoCompraRequest, FinalizarRequisicaoCompraResponse } from "../daos/update/finalizar_requisicao_compra";
import { GetColetaPrecoByIdRequest, GetColetaPrecoByIdResponse } from "../daos/read/get_coleta_preco_by_id";
import { CreateColetaPrecoRequest, CreateColetaPrecoResponse } from "../daos/create/create_coleta_preco";
import { UpdateColetaPrecoRequest, UpdateColetaPrecoResponse } from "../daos/update/update_coleta_preco";
import { GetFornecedorByFamiliaDropDownRequest, GetFornecedorByFamiliaDropDownResponse } from "../daos/read/get_fornecedor_by_familia_drop_down";
import { GetProdutosServicosByIdRequisicaoCompraDropDownRequest, GetProdutosServicosByIdRequisicaoCompraDropDownResponse } from "../daos/read/get_produtos_servicos_by_id_requisicao_compra_drop_down";
import { CreateColetaPrecoFornecedorRequest, CreateColetaPrecoFornecedorResponse } from "../daos/create/create_coleta_preco_fornecedor";
import { GetAllColetaPrecoFornecedorRequest, GetAllColetaPrecoFornecedorResponse } from "../daos/read/get_all_coleta_preco_fornecedor";
import { GetFornecedoresDetalheDropDownRequest, GetFornecedoresDetalheDropDownResponse } from "../daos/read/get_fornecedores_detalhe_drop_down";
import { GetAllColetaProdutoServicoRequest, GetAllColetaProdutoServicoResponse } from "../daos/read/get_all_coleta_produto_servico";
import { UpdateColetaPrecoFornecedorRequest, UpdateColetaPrecoFornecedorResponse } from "../daos/update/update_coleta_preco_fornecedor";
import { CopyColetaPrecoFornecedorRequest, CopyColetaPrecoFornecedorResponse } from "../daos/create/copy_coleta_preco_fornecedor";
import { DeleteColetaPrecoFornecedorRequest, DeleteColetaPrecoFornecedorResponse } from "../daos/delete/delete_coleta_preco_fornecedor";
import { AprovarColetaPrecoFornecedorRequest, AprovarColetaPrecoFornecedorResponse } from "../daos/update/aprovar_coleta_preco_fornecedor";
import { CancelarAprovacaoColetaPrecoFornecedorRequest, CancelarAprovacaoColetaPrecoFornecedorResponse } from "../daos/update/cancelar_aprovacao_coleta_preco_fornecedor";
import { GerarOrdemCompraColetaPrecoRequest, GerarOrdemCompraColetaPrecoResponse } from "../daos/create/gerar_ordem_compra_coleta_preco";
import { ConfigurarPagamentoColetaPrecoRequest, ConfigurarPagamentoColetaPrecoResponse } from "../daos/create/configurar_pagamento_coleta_preco";
import { GetConfigurarPagamentoColetaPrecoRequest, GetConfigurarPagamentoColetaPrecoResponse } from "../daos/read/get_configurar_pagamento_coleta_preco";
import { DeleteConfigurarPagamentoColetaPrecoRequest, DeleteConfigurarPagamentoColetaPrecoResponse } from "../daos/delete/delete_configurar_pagamento_coleta_preco";
import { GetAllOrdemCompraRequest, GetAllOrdemCompraResponse } from "../daos/read/get_all_ordem_compra";
import { SendEmailOrdemCompraRequest, SendEmailOrdemCompraResponse } from "../daos/read/send_email_ordem_compra";
import { GetOrdemCompraByIdRequest, GetOrdemCompraByIdResponse } from "../daos/read/get_ordem_compra_by_id";
import { GetOrdemCompraInformacaoFaturamentoDropDownRequest, GetOrdemCompraInformacaoFaturamentoDropDownResponse } from "../daos/read/get_ordem_compra_informacao_faturamento_drop_down";
import { GetInformacaoFaturamentoByIdRequest, GetInformacaoFaturamentoByIdResponse } from "../daos/read/get_informacao_faturamento_by_id";
import { GetOrdemCompraCentroCustoDropDownRequest, GetOrdemCompraCentroCustoDropDownResponse } from "../daos/read/get_ordem_compra_centro_custo_drop_down";
import { GetOrdemCompraBancoDropDownRequest, GetOrdemCompraBancoDropDownResponse } from "../daos/read/get_ordem_compra_banco_drop_down";
import { UpdateOrdemCompraRequest, UpdateOrdemCompraResponse } from "../daos/update/update_ordem_compra";
import { GetOrdemCompraAvaliacaoFornecedorRequest, GetOrdemCompraAvaliacaoFornecedorResponse } from "../daos/read/get_ordem_compra_avaliacao_fornecedor";
import { UpdateAvaliacaoOrdemCompraRequest, UpdateAvaliacaoOrdemCompraResponse } from "../daos/update/update_avaliacao_ordem_compra";
import { GetProdutoServicoByIdOrdemCompraDropDownRequest, GetProdutoServicoByIdOrdemCompraDropDownResponse } from "../daos/read/get_produto_servico_by_id_ordem_compra_drop_down";
import { CreateAvaliacaoOrdemCompraColetaRequest, CreateAvaliacaoOrdemCompraColetaResponse } from "../daos/create/create_avaliacao_ordem_compra_coleta";
import { CancelarOrdemCompraRequest, CancelarOrdemCompraResponse } from "../daos/update/cancelar_ordem_compra";
import { GetOrdemCompraCanceladoStatusRequest, GetOrdemCompraCanceladoStatusResponse } from "../daos/read/get_ordem_compra_cancelado_status";
import { GetAllOrdemCompraPrecosRequest, GetAllOrdemCompraPrecosResponse } from "../daos/read/get_all_ordem_compra_precos";
import { GetOrdemCompraTotalValoresRequest, GetOrdemCompraTotalValoresResponse } from "../daos/read/get_ordem_compra_total_valores";
import { UpdateAtributosComprasRequest, UpdateAtributosComprasResponse } from "../daos/update/update_atributos_compras";
import { GetAllEntregaProdutoServicoRequest, GetAllEntregaProdutoServicoResponse } from "../daos/read/get_all_entrega_produto_servico";
import { DeleteEntregaProdutoServicoRequest, DeleteEntregaProdutoServicoResponse } from "../daos/read/delete_entrega_produto_servico";
import { GetAllOCProdutoServicosParaEntregaRequest, GetAllOCProdutoServicosParaEntregaResponse } from "../daos/read/get_all_o_c_produto_servicos_para_entrega";
import { DeleteColetaProdutoServicoRequest, DeleteColetaProdutoServicoResponse } from "../daos/delete/delete_coleta_produto_servico";
import { UpdateStatusColetaPrecoRequest, UpdateStatusColetaPrecoResponse } from "../daos/update/update_status_coleta_preco";
import { UpdateStatusRequisicaoCompraRequest, UpdateStatusRequisicaoCompraResponse } from "../daos/update/update_status_requisicao_compra";
import { GetDashboardComprasRequest, GetDashboardComprasResponse } from "../daos/read/get_dashboard_compras";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { DownloadRequisicaoCompraArquivoRequest } from "../daos/read/download_requisicao_compra_arquivo";
import { DownloadColetaPrecoArquivoRequest } from "../daos/read/download_coleta_preco_arquivo";
import { DownloadOrdemCompraArquivoRequest } from "../daos/read/download_ordem_compra_arquivo";
import { DownloadEntregaOrdemCompraArquivoRequest } from "../daos/read/download_entrega_ordem_compra_arquivo";
import { DownloadBoletoAvaliacaoOrdemCompraRequest } from "../daos/read/download_boleto_avaliacao_ordem_compra";
import { CreateFuncionarioAprovadorRequest, CreateFuncionarioAprovadorResponse } from "../daos/create/create_funcionario_aprovador";
import { UpdateFuncionarioAprovadorRequest, UpdateFuncionarioAprovadorResponse } from "../daos/update/update_funcionario_aprovador";
import { DeleteFuncionarioAprovadorRequest, DeleteFuncionarioAprovadorResponse } from "../daos/delete/delete_funcionario_aprovador";
import { GetFuncionarioParaAprovacaoDropDownRequest, GetFuncionarioParaAprovacaoDropDownResponse } from "../daos/read/get_funcionario_para_aprovacao_drop_down";
import { GetFuncionariosAprovadoresDropDownRequest, GetFuncionariosAprovadoresDropDownResponse } from "../daos/read/get_funcionarios_aprovadores_drop_down";
import { SendAprovacaoColetaPrecoRequest, SendAprovacaoColetaPrecoResponse } from "../daos/update/send_aprovacao_coleta_preco";

/**
 * ComprasService
 */
export class ComprasService implements IComprasService {

	async getFornecedoresFamiliasDropDown(request: GetFornecedoresFamiliasDropDownRequest): Promise<GetFornecedoresFamiliasDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/familias/dropdown`, request);
			const response = handleAxiosResponse<GetFornecedoresFamiliasDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedoresAtividadesDropDown(request: GetFornecedoresAtividadesDropDownRequest): Promise<GetFornecedoresAtividadesDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/atividades/dropdown`, request);
			const response = handleAxiosResponse<GetFornecedoresAtividadesDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedorByFamiliaDropDown(request: GetFornecedorByFamiliaDropDownRequest): Promise<GetFornecedorByFamiliaDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/by-familia/dropdown`, request);
			const response = handleAxiosResponse<GetFornecedorByFamiliaDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getProdutosServicosByIdRequisicaoCompraDropDown(request: GetProdutosServicosByIdRequisicaoCompraDropDownRequest): Promise<GetProdutosServicosByIdRequisicaoCompraDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/produtos-servicos/by-requisicao-compra/dropdown`, request);
			const response = handleAxiosResponse<GetProdutosServicosByIdRequisicaoCompraDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedoresDetalheDropDown(request: GetFornecedoresDetalheDropDownRequest): Promise<GetFornecedoresDetalheDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/detalhes/dropdown`, request);
			const response = handleAxiosResponse<GetFornecedoresDetalheDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraInformacaoFaturamentoDropDown(request: GetOrdemCompraInformacaoFaturamentoDropDownRequest): Promise<GetOrdemCompraInformacaoFaturamentoDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/informacoes-faturamento/dropdown`, request);
			const response = handleAxiosResponse<GetOrdemCompraInformacaoFaturamentoDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraCentroCustoDropDown(request: GetOrdemCompraCentroCustoDropDownRequest): Promise<GetOrdemCompraCentroCustoDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/centro-custos/dropdown`, request);
			const response = handleAxiosResponse<GetOrdemCompraCentroCustoDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraBancoDropDown(request: GetOrdemCompraBancoDropDownRequest): Promise<GetOrdemCompraBancoDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/bancos/dropdown`, request);
			const response = handleAxiosResponse<GetOrdemCompraBancoDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getProdutoServicoByIdOrdemCompraDropDown(request: GetProdutoServicoByIdOrdemCompraDropDownRequest): Promise<GetProdutoServicoByIdOrdemCompraDropDownResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/produtos-servicos/by-ordem-compra/dropdown`, request);
			const response = handleAxiosResponse<GetProdutoServicoByIdOrdemCompraDropDownResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	//#region PRODUTO SERVICO
	async createProdutoServico(request: CreateProdutoServicoRequest): Promise<CreateProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/produtoservico/create`, request);
			const response = handleAxiosResponse<CreateProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	};

	//#endregion

	//#region FORNECEDOR

	async createFornecedorSimplificado(request: CreateFornecedorSimplificadoRequest): Promise<CreateFornecedorSimplificadoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedor/create`, request);
			const response = handleAxiosResponse<CreateFornecedorSimplificadoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	};

	async getAllFornecedor(request: GetAllFornecedorRequest): Promise<GetAllFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores`, request);
			const response = handleAxiosResponse<GetAllFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteFornecedor({ idFornecedor }: DeleteFornecedorRequest): Promise<DeleteFornecedorResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/fornecedores/${idFornecedor}/delete`);
			const response = handleAxiosResponse<GetAllFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllCriterioAvaliacaoFornecedor(request: GetAllCriterioAvaliacaoFornecedorRequest): Promise<GetAllCriterioAvaliacaoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/criterios-avaliacao-fornecedor`, request);
			const response = handleAxiosResponse<GetAllCriterioAvaliacaoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createAvaliacaoFornecedor(request: CreateAvaliacaoFornecedorRequest): Promise<CreateAvaliacaoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/avaliacao-fornecedor/create`, request);
			const response = handleAxiosResponse<CreateAvaliacaoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedorById({ idFornecedor }: GetFornecedorByIdRequest): Promise<GetFornecedorByIdResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/fornecedores/${idFornecedor}`);
			const response = handleAxiosResponse<GetFornecedorByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getBancosByIdFornecedor({ idFornecedor }: GetBancosByIdFornecedorRequest): Promise<GetBancosByIdFornecedorResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/fornecedores/${idFornecedor}/bancos`);
			const response = handleAxiosResponse<GetBancosByIdFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAvaliacoesByIdFornecedor({ idFornecedor }: GetAvaliacoesByIdFornecedorRequest): Promise<GetAvaliacoesByIdFornecedorResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/fornecedores/${idFornecedor}/avaliacoes`);
			const response = handleAxiosResponse<GetAvaliacoesByIdFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getDocumentosByIdFornecedor({ idFornecedor }: GetDocumentosByIdFornecedorRequest): Promise<GetDocumentosByIdFornecedorResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/fornecedores/${idFornecedor}/documentos`);
			const response = handleAxiosResponse<GetDocumentosByIdFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedorDocumentoFileContent({ idFornecedor, idFornecedorArquivo }: GetFornecedorDocumentoFileContentRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({ responseType: 'blob' }).get(`/compras/fornecedores/${idFornecedor}/documentos/${idFornecedorArquivo}/download`);
			const response = handleAxiosResponse<Blob>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async toggleFornecedorDesqualificado({ idFornecedor }: ToggleFornecedorDesqualificadoRequest): Promise<ToggleFornecedorDesqualificadoResponse> {
		try {
			const result = await axiosInstance({}).patch(`/compras/fornecedores/${idFornecedor}/toggle-desqualificado`);
			const response = handleAxiosResponse<ToggleFornecedorDesqualificadoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllFornecedorQualificacao({ idFornecedor }: GetAllFornecedorQualificacaoRequest): Promise<GetAllFornecedorQualificacaoResponse> {
		try {
			const paramUrl = idFornecedor !== null ? `/${idFornecedor}` : '';
			const result = await axiosInstance({}).get(`/compras/fornecedores/qualificacoes${paramUrl}`);
			const response = handleAxiosResponse<GetAllFornecedorQualificacaoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getFornecedorAvaliacaoItensById({ idAvaliacaoFornecedor }: GetFornecedorAvaliacaoItensByIdRequest): Promise<GetFornecedorAvaliacaoItensByIdResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/fornecedores/avaliacoes/${idAvaliacaoFornecedor}/itens`);
			const response = handleAxiosResponse<GetFornecedorAvaliacaoItensByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createFornecedorBanco({ idFornecedor, ...request }: CreateFornecedorBancoRequest): Promise<CreateFornecedorBancoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/${idFornecedor}/bancos/create`, request);
			const response = handleAxiosResponse<CreateFornecedorBancoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateFornecedorBanco({ idFornecedor, ...request }: UpdateFornecedorBancoRequest): Promise<UpdateFornecedorBancoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/${idFornecedor}/bancos/update`, request);
			const response = handleAxiosResponse<UpdateFornecedorBancoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteFornecedorBanco({ idFornecedor, idBanco }: DeleteFornecedorBancoRequest): Promise<DeleteFornecedorBancoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/fornecedores/${idFornecedor}/bancos/${idBanco}/delete`);
			const response = handleAxiosResponse<DeleteFornecedorBancoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateFornecedorAvaliacao({ idFornecedor, ...request }: UpdateFornecedorAvaliacaoRequest): Promise<UpdateFornecedorAvaliacaoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/${idFornecedor}/avaliacoes/update`, request);
			const response = handleAxiosResponse<UpdateFornecedorAvaliacaoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteFornecedorAvaliacao({ idFornecedor, idAvaliacaoFornecedor }: DeleteFornecedorAvaliacaoRequest): Promise<DeleteFornecedorAvaliacaoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/fornecedores/${idFornecedor}/avaliacoes/${idAvaliacaoFornecedor}/delete`);
			const response = handleAxiosResponse<DeleteFornecedorAvaliacaoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createFornecedorDocumento({ idFornecedor, ...request }: CreateFornecedorDocumentoRequest): Promise<CreateFornecedorDocumentoResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/fornecedores/${idFornecedor}/documentos/create`, formData, config);
			const response = handleAxiosResponse<CreateFornecedorDocumentoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateFornecedorDocumento({ idFornecedor, ...request }: UpdateFornecedorDocumentoRequest): Promise<UpdateFornecedorDocumentoResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/fornecedores/${idFornecedor}/documentos/update`, formData, config);
			const response = handleAxiosResponse<UpdateFornecedorDocumentoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteFornecedorDocumento({ idFornecedor, idFornecedorArquivo }: DeleteFornecedorDocumentoRequest): Promise<DeleteFornecedorDocumentoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/fornecedores/${idFornecedor}/documentos/${idFornecedorArquivo}/delete`);
			const response = handleAxiosResponse<DeleteFornecedorDocumentoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createFornecedor(request: CreateFornecedorRequest): Promise<CreateFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/create`, request);
			const response = handleAxiosResponse<CreateFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateFornecedor(request: UpdateFornecedorRequest): Promise<UpdateFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/fornecedores/update`, request);
			const response = handleAxiosResponse<UpdateFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	//#endregion

	//#region ServicosProdutos

	async getAllServicoProduto(request: GetAllServicoProdutoRequest): Promise<GetAllServicoProdutoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/servicos-produtos`, request);
			const response = handleAxiosResponse<GetAllServicoProdutoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createServicoProduto(request: CreateServicoProdutoRequest): Promise<CreateServicoProdutoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/servicos-produtos/create`, request);
			const response = handleAxiosResponse<CreateServicoProdutoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateServicoProduto(request: UpdateServicoProdutoRequest): Promise<UpdateServicoProdutoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/servicos-produtos/update`, request);
			const response = handleAxiosResponse<UpdateServicoProdutoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteServicoProduto({ idProdutoServico }: DeleteServicoProdutoRequest): Promise<DeleteServicoProdutoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/servicos-produtos/${idProdutoServico}/delete`);
			const response = handleAxiosResponse<DeleteServicoProdutoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async inativarServicoProdutoLoteServicoProduto(request: InativarServicoProdutoLoteServicoProdutoRequest): Promise<InativarServicoProdutoLoteServicoProdutoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/servicos-produtos/inativar-lote`, request);
			const response = handleAxiosResponse<DeleteServicoProdutoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllRequisicaoCompra(request: GetAllRequisicaoCompraRequest): Promise<GetAllRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras`, request);
			const response = handleAxiosResponse<GetAllRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getRequisicaoCompraById({ idRequisicaoProdutoServico }: GetRequisicaoCompraByIdRequest): Promise<GetRequisicaoCompraByIdResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/requisicoes-compras/${idRequisicaoProdutoServico}`);
			const response = handleAxiosResponse<GetRequisicaoCompraByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteRequisicaoCompra(request: DeleteRequisicaoCompraRequest): Promise<DeleteRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/delete`, request);
			const response = handleAxiosResponse<DeleteRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async sendEmailRequisicaoCompra({ idRequisicaoCompra, ...request }: SendEmailRequisicaoCompraRequest): Promise<SendEmailRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/${idRequisicaoCompra}/send-email`, request);
			const response = handleAxiosResponse<SendEmailRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async copyRequisicaoCompra({ idRequisicaoCompra }: CopyRequisicaoCompraRequest): Promise<CopyRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/requisicoes-compras/${idRequisicaoCompra}/copy`);
			const response = handleAxiosResponse<CopyRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async finalizarLoteRequisicaoCompra(request: FinalizarLoteRequisicaoCompraRequest): Promise<FinalizarLoteRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/finalizar-lote`, request);
			const response = handleAxiosResponse<FinalizarLoteRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createRequisicaoCompra(request: CreateRequisicaoCompraRequest): Promise<CreateRequisicaoCompraResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/create`, formData, config);
			const response = handleAxiosResponse<CreateRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateRequisicaoCompra(request: UpdateRequisicaoCompraRequest): Promise<UpdateRequisicaoCompraResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/update`, formData, config);
			const response = handleAxiosResponse<UpdateRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllRequisicaoProdutoServico(request: GetAllRequisicaoProdutoServicoRequest): Promise<GetAllRequisicaoProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/produtos-servicos`, request);
			const response = handleAxiosResponse<GetAllRequisicaoProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllAlteracaoRequisicaoCompraProdutoServico(request: GetAllAlteracaoRequisicaoCompraProdutoServicoRequest): Promise<GetAllAlteracaoRequisicaoCompraProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/alteracoes-produtos-servicos`, request);
			const response = handleAxiosResponse<GetAllAlteracaoRequisicaoCompraProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createRequisicaoCompraProdutoServico(request: CreateRequisicaoCompraProdutoServicoRequest): Promise<CreateRequisicaoCompraProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/produtos-servicos/create`, request);
			const response = handleAxiosResponse<CreateRequisicaoCompraProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateRequisicaoCompraProdutoServico(request: UpdateRequisicaoCompraProdutoServicoRequest): Promise<UpdateRequisicaoCompraProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/produtos-servicos/update`, request);
			const response = handleAxiosResponse<UpdateRequisicaoCompraProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteRequisicaoCompraProdutoServico({ idRequisicaoProdutoServico }: DeleteRequisicaoCompraProdutoServicoRequest): Promise<DeleteRequisicaoCompraProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/requisicoes-compras/produtos-servicos/${idRequisicaoProdutoServico}/delete`);
			const response = handleAxiosResponse<UpdateRequisicaoCompraProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllColetaPreco(request: GetAllColetaPrecoRequest): Promise<GetAllColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos`, request);
			const response = handleAxiosResponse<GetAllColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getColetaPrecoById({ idColetaPreco }: GetColetaPrecoByIdRequest): Promise<GetColetaPrecoByIdResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/coletas-precos/${idColetaPreco}`);
			const response = handleAxiosResponse<GetColetaPrecoByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async copyColetaPreco({ idColetaPreco, ...request }: CopyColetaPrecoRequest): Promise<CopyColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos/${idColetaPreco}/copy`, request);
			const response = handleAxiosResponse<GetAllColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteColetaPreco(request: DeleteColetaPrecoRequest): Promise<DeleteColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos/delete`, request);
			const response = handleAxiosResponse<DeleteColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async finalizarRequisicaoCompra({ idRequisicaoCompra, ...request }: FinalizarRequisicaoCompraRequest): Promise<FinalizarRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/${idRequisicaoCompra}/finalizar-requisicao`, request);
			const response = handleAxiosResponse<FinalizarRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createColetaPreco(request: CreateColetaPrecoRequest): Promise<CreateColetaPrecoResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/coletas-precos/create`, formData, config);
			const response = handleAxiosResponse<CreateColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateColetaPreco(request: UpdateColetaPrecoRequest): Promise<UpdateColetaPrecoResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const config = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/coletas-precos/update`, formData, config);
			const response = handleAxiosResponse<UpdateColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createColetaPrecoFornecedor(request: CreateColetaPrecoFornecedorRequest): Promise<CreateColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/create`, request);
			const response = handleAxiosResponse<CreateColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateColetaPrecoFornecedor(request: UpdateColetaPrecoFornecedorRequest): Promise<UpdateColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/update`, request);
			const response = handleAxiosResponse<UpdateColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteColetaPrecoFornecedor({ idColetaPrecoFornecedor }: DeleteColetaPrecoFornecedorRequest): Promise<DeleteColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/coletas-precos-fornecedores/${idColetaPrecoFornecedor}/delete`);
			const response = handleAxiosResponse<DeleteColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async copyColetaPrecoFornecedor({ idColetaPrecoFornecedor, ...request }: CopyColetaPrecoFornecedorRequest): Promise<CopyColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/${idColetaPrecoFornecedor}/copy`, request);
			const response = handleAxiosResponse<CopyColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllColetaPrecoFornecedor(request: GetAllColetaPrecoFornecedorRequest): Promise<GetAllColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores`, request);
			const response = handleAxiosResponse<GetAllColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllColetaProdutoServico({ idColetaPrecoFornecedor, ...request }: GetAllColetaProdutoServicoRequest): Promise<GetAllColetaProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/${idColetaPrecoFornecedor}/produtos-servicos`, request);
			const response = handleAxiosResponse<GetAllColetaProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async aprovarColetaPrecoFornecedor({ idColetaPrecoFornecedor, ...request }: AprovarColetaPrecoFornecedorRequest): Promise<AprovarColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/${idColetaPrecoFornecedor}/aprovar`, request);
			const response = handleAxiosResponse<AprovarColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async cancelarAprovacaoColetaPrecoFornecedor(request: CancelarAprovacaoColetaPrecoFornecedorRequest): Promise<CancelarAprovacaoColetaPrecoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos-fornecedores/cancelar-aprovacao`, request);
			const response = handleAxiosResponse<CancelarAprovacaoColetaPrecoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async gerarOrdemCompraColetaPreco({ idColetaPreco, ...request }: GerarOrdemCompraColetaPrecoRequest): Promise<GerarOrdemCompraColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos/${idColetaPreco}/gerar-ordem-compra`, request);
			const response = handleAxiosResponse<GerarOrdemCompraColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async configurarPagamentoColetaPreco({ idColetaPreco, ...request }: ConfigurarPagamentoColetaPrecoRequest): Promise<ConfigurarPagamentoColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos/${idColetaPreco}/configurar-pagamento/create`, request);
			const response = handleAxiosResponse<ConfigurarPagamentoColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getConfigurarPagamentoColetaPreco({ idColetaPreco }: GetConfigurarPagamentoColetaPrecoRequest): Promise<GetConfigurarPagamentoColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/coletas-precos/${idColetaPreco}/configurar-pagamento`);
			const response = handleAxiosResponse<GetConfigurarPagamentoColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteConfigurarPagamentoColetaPreco({ idColetaPreco }: DeleteConfigurarPagamentoColetaPrecoRequest): Promise<DeleteConfigurarPagamentoColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/coletas-precos/${idColetaPreco}/configurar-pagamento/delete`);
			const response = handleAxiosResponse<DeleteConfigurarPagamentoColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllOrdemCompra(request: GetAllOrdemCompraRequest): Promise<GetAllOrdemCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras`, request);
			const response = handleAxiosResponse<GetAllOrdemCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraById({ idOrdemCompra, ...request }: GetOrdemCompraByIdRequest): Promise<GetOrdemCompraByIdResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}`, request);
			const response = handleAxiosResponse<GetOrdemCompraByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async sendEmailOrdemCompra({ idOrdemCompra, ...request }: SendEmailOrdemCompraRequest): Promise<SendEmailOrdemCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/send-email`, request);
			const response = handleAxiosResponse<SendEmailOrdemCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getInformacaoFaturamentoById({ idInformacaoFaturamento }: GetInformacaoFaturamentoByIdRequest): Promise<GetInformacaoFaturamentoByIdResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/informacoes-faturamento/${idInformacaoFaturamento}`);
			const response = handleAxiosResponse<GetInformacaoFaturamentoByIdResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateOrdemCompra(request: UpdateOrdemCompraRequest): Promise<UpdateOrdemCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/update`, request);
			const response = handleAxiosResponse<UpdateOrdemCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraAvaliacaoFornecedor({ idOrdemCompra }: GetOrdemCompraAvaliacaoFornecedorRequest): Promise<GetOrdemCompraAvaliacaoFornecedorResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes`);
			const response = handleAxiosResponse<GetOrdemCompraAvaliacaoFornecedorResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateAvaliacaoOrdemCompra({ idOrdemCompra, ...request }: UpdateAvaliacaoOrdemCompraRequest): Promise<UpdateAvaliacaoOrdemCompraResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const options = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/update`, formData, options);
			const response = handleAxiosResponse<UpdateAvaliacaoOrdemCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createAvaliacaoOrdemCompraColeta({ idOrdemCompra, ...request }: CreateAvaliacaoOrdemCompraColetaRequest): Promise<CreateAvaliacaoOrdemCompraColetaResponse> {
		try {
			const formData = RequestObjectToFormData(request);
			const options = { headers: { 'Content-Type': 'multipart/form-data' } };
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/coleta/create`, formData, options);
			const response = handleAxiosResponse<CreateAvaliacaoOrdemCompraColetaResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async createEntradasEstoqueOrdemCompra({ idOrdemCompra, ...request }: CreateEntradasEstoqueOrdemCompraRequest): Promise<CreateEntradasEstoqueOrdemCompraResponse> {
		try {
			const result = await axiosInstance({}).post(
				`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/entrada-estoque/createMulti`,
				request,
			);
			return handleAxiosResponse<CreateEntradasEstoqueOrdemCompraResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async cancelarOrdemCompra({ idOrdemCompra, ...request }: CancelarOrdemCompraRequest): Promise<CancelarOrdemCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/cancelar`, request);
			const response = handleAxiosResponse<CancelarOrdemCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraCanceladoStatus({ idOrdemCompra }: GetOrdemCompraCanceladoStatusRequest): Promise<GetOrdemCompraCanceladoStatusResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/${idOrdemCompra}/status-cancelar`);
			const response = handleAxiosResponse<GetOrdemCompraCanceladoStatusResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllOrdemCompraPrecos(request: GetAllOrdemCompraPrecosRequest): Promise<GetAllOrdemCompraPrecosResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras-precos`, request);
			const response = handleAxiosResponse<GetAllOrdemCompraPrecosResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getOrdemCompraTotalValores(request: GetOrdemCompraTotalValoresRequest): Promise<GetOrdemCompraTotalValoresResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras-precos/valores`, request);
			const response = handleAxiosResponse<GetOrdemCompraTotalValoresResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateAtributosCompras(request: UpdateAtributosComprasRequest): Promise<UpdateAtributosComprasResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/atributos-compras/update`, request);
			const response = handleAxiosResponse<UpdateAtributosComprasResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllEntregaProdutoServico({ idOrdemCompra, ...request }: GetAllEntregaProdutoServicoRequest): Promise<GetAllEntregaProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/entrega-produtos-servicos`, request);
			const response = handleAxiosResponse<GetAllEntregaProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteEntregaProdutoServico({ idOrdemCompra, idProdutoServicoEntregue }: DeleteEntregaProdutoServicoRequest): Promise<DeleteEntregaProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/entrega-produtos-servicos/${idProdutoServicoEntregue}/delete`);
			const response = handleAxiosResponse<DeleteEntregaProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllOCProdutoServicosParaEntrega({ idOrdemCompra, ...request }: GetAllOCProdutoServicosParaEntregaRequest): Promise<GetAllOCProdutoServicosParaEntregaResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/ordem-compras/${idOrdemCompra}/produtos-servicos/entrega`, request);
			const response = handleAxiosResponse<GetAllOCProdutoServicosParaEntregaResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteColetaProdutoServico({ idColetaPreco, idColetaProdutoServico }: DeleteColetaProdutoServicoRequest): Promise<DeleteColetaProdutoServicoResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/coletas-precos-fornecedores/${idColetaPreco}/produtos-servicos/${idColetaProdutoServico}/delete`);
			const response = handleAxiosResponse<DeleteColetaProdutoServicoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	//#endregion

	async updateStatusRequisicaoCompra({ idRequisicaoCompra, ...request }: UpdateStatusRequisicaoCompraRequest): Promise<UpdateStatusRequisicaoCompraResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/requisicoes-compras/${idRequisicaoCompra}/update-status`, request);
			const response = handleAxiosResponse<UpdateStatusRequisicaoCompraResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async updateStatusColetaPreco({ idColetaPreco, ...request }: UpdateStatusColetaPrecoRequest): Promise<UpdateStatusColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/coletas-precos/${idColetaPreco}/update-status`, request);
			const response = handleAxiosResponse<UpdateStatusColetaPrecoResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getDashboardCompras(request: GetDashboardComprasRequest): Promise<GetDashboardComprasResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/dashboard/information`);
			const response = handleAxiosResponse<GetDashboardComprasResponse>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async downloadRequisicaoCompraArquivo({ idRequisicaoCompra, nroArquivo }: DownloadRequisicaoCompraArquivoRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({ responseType: 'blob' }).get(`/compras/requisicoes-compras/${idRequisicaoCompra}/arquivos/${nroArquivo}/download`);
			const response = handleAxiosResponse<Blob>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async downloadOrdemCompraArquivo({ idOrdemCompra }: DownloadOrdemCompraArquivoRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/download`, { responseType: 'blob' });
			return result.data as Blob;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async downloadColetaPrecoArquivo({ idColetaPreco, nroArquivo }: DownloadColetaPrecoArquivoRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({ responseType: 'blob' }).get(`/compras/coletas-precos/${idColetaPreco}/arquivos/${nroArquivo}/download`);
			const response = handleAxiosResponse<Blob>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async downloadEntregaOrdemCompraArquivo({ idOrdemCompra, idProdutoServicoEntregue }: DownloadEntregaOrdemCompraArquivoRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/coleta/${idProdutoServicoEntregue}/download`, { responseType: 'blob' });
			const response = handleAxiosResponse<Blob>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async downloadBoletoAvaliacaoOrdemCompra({ idOrdemCompra }: DownloadBoletoAvaliacaoOrdemCompraRequest): Promise<Blob> {
		try {
			const result = await axiosInstance({}).get(`/compras/ordem-compras/${idOrdemCompra}/avaliacoes/boleto-download`, { responseType: 'blob' });
			const response = handleAxiosResponse<Blob>(result);
			return response;
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async getAllFuncionariosAprovadores(request: GetAllFuncionariosAprovadoresRequest): Promise<GetAllFuncionariosAprovadoresResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/funcionarios-aprovadores`, request);
			return handleAxiosResponse<GetAllFuncionariosAprovadoresResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}

	async createFuncionarioAprovador(request: CreateFuncionarioAprovadorRequest): Promise<CreateFuncionarioAprovadorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/funcionarios-aprovadores/create`, request);
			return handleAxiosResponse<CreateFuncionarioAprovadorResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}

	async updateFuncionarioAprovador(idFuncionarioAprovador: number, request: UpdateFuncionarioAprovadorRequest): Promise<UpdateFuncionarioAprovadorResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/funcionarios-aprovadores/${idFuncionarioAprovador}/update`, request);
			return handleAxiosResponse<UpdateFuncionarioAprovadorResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisição!");
			}
		}
	}

	async deleteFuncionarioAprovador({ idFuncionarioAprovador }: DeleteFuncionarioAprovadorRequest): Promise<DeleteFuncionarioAprovadorResponse> {
		try {
			const result = await axiosInstance({}).delete(`/compras/funcionarios-aprovadores/${idFuncionarioAprovador}/delete`);
			return handleAxiosResponse<DeleteFuncionarioAprovadorResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}

	async getFuncionarioParaAprovacaoDropDown(_: GetFuncionarioParaAprovacaoDropDownRequest): Promise<GetFuncionarioParaAprovacaoDropDownResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/funcionarios/promocao-aprovacao/dropdown`);
			return handleAxiosResponse<GetFuncionarioParaAprovacaoDropDownResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}

	async getFuncionariosAprovadoresDropDown(_: GetFuncionariosAprovadoresDropDownRequest): Promise<GetFuncionariosAprovadoresDropDownResponse> {
		try {
			const result = await axiosInstance({}).get(`/compras/funcionarios/aprovadores/dropdown`);
			return handleAxiosResponse<GetFuncionariosAprovadoresDropDownResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}

	async sendAprovacaoColetaPreco(request: SendAprovacaoColetaPrecoRequest): Promise<SendAprovacaoColetaPrecoResponse> {
		try {
			const result = await axiosInstance({}).post(`/compras/funcionarios/aprovacao/send-mail`, request);
			return handleAxiosResponse<SendAprovacaoColetaPrecoResponse>(result);
		} catch (error: unknown) {
			if (typeof error === "string") {
				throw new Error(error);
			} else if (isBaseError(error)) {
				throw toBaseError(error);
			} else if (error instanceof AxiosError) {
				throw new Error(error.message);
			} else if (error instanceof Error) {
				throw error;
			} else {
				throw new Error("Falha ao executar requisi\u00e7\u00e3o!");
			}
		}
	}
}
